const postsLoader = () => {
  jQuery(($) => {
    $("[data-loader]").each((index, element) => {
      const button = $(element);
      let data = button.data("loader");
      const section = button.parents(data.wrapper);
      const wrapper = section.find(".items");
      const term = $('[name="term"]', section);

      wrapper.on("reset", () => {
        data = button.data("loader");

        wrapper.children().remove();

        data.offset = 0;

        button.trigger("click");
      });

      button.click(() => {
        data.action = "load_posts";

        $.ajax({
          url: window.template.ajaxurl,
          type: "post",
          dataType: "json",
          data,
          success: (response) => {
            if (response.result) {
              const posts = $(response.result);

              wrapper.append(posts);

              data.offset += data.number;

              if (response.more) {
                button.removeClass("is_hidden");
              } else {
                button.addClass("is_hidden");
              }

              section.trigger("init");
            } else {
              button.addClass("is_hidden");
            }
          },
          beforeSend() {
            button.addClass("is_loading");
          },
          complete() {
            button.removeClass("is_loading");
          },
        });
      });

      term.change(() => {
        const termId = term.val();
        const currentData = button.data("loader");

        currentData.terms = [];

        if (termId) {
          currentData.terms = [termId];
        }

        button.data("loader", currentData);

        wrapper.trigger("reset");
      });
    });
  });
};

// eslint-disable-next-line
export {postsLoader};
